import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  TextField,
  IconButton,
  Stack,
  Button,
} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import EmailIcon from '@mui/icons-material/Email';

interface ShareCardProps {
  appLink: string;
  onCopy: () => void;
  onWhatsApp: () => void;
  onEmail: () => void;
}

const ShareCard: React.FC<ShareCardProps> = ({
  appLink,
  onCopy,
  onWhatsApp,
  onEmail
}) => (
  <Card sx={{ mb: 3 }}>
    <CardContent>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Invite your friends to use SMEDCO Mobile by sharing the app link below.
      </Typography>
      <TextField
        value={appLink}
        fullWidth
        InputProps={{
          readOnly: true,
          endAdornment: (
            <IconButton onClick={onCopy} edge="end">
              <ContentCopyIcon />
            </IconButton>
          )
        }}
        sx={{ mb: 2 }}
      />
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
        <Button
          variant="contained"
          color="primary"
          startIcon={<WhatsAppIcon />}
          fullWidth
          onClick={onWhatsApp}
        >
          Share via WhatsApp
        </Button>
        <Button
          variant="contained"
          color="secondary"
          startIcon={<EmailIcon />}
          fullWidth
          onClick={onEmail}
        >
          Share via Email
        </Button>
      </Stack>
    </CardContent>
  </Card>
);

export default ShareCard; 